export default __webpack_public_path__ + "22912e159ec08c24eb4aa96f8355664f.png";